// Module
var code = `<!-- ko using: model -->
<div class="svc-creator-tab__content">
    <div class="svc-json-editor-tab__content">
        <div class="svc-json-editor-tab__ace-editor"></div>
        <div class="svc-json-editor-tab__errros_list" data-bind="visible: hasErrors">
            <!-- ko component: { name: "sv-list", params: { model: errorList } } -->
            <!-- /ko -->
        </div>
    </div>
</div>
<!-- /ko -->`;
// Exports
export default code;